const pad2 = (number)=>{   
    var str = '' + number;
    while (str.length < 2) {
        str = '0' + str;
    }       
    return str;    
}


const timeStr = (dt) =>{    
    let str = dt.getFullYear()+
    pad2((dt.getMonth()+1))+
    pad2(dt.getDate())
    return str
}

const timeObj = (str) =>{
    let par = ''
    par = str.slice(0, 4)+'/'+str.slice(4, 6)+'/'+str.slice(6,8)   
    return new Date(par)
}

export{timeStr, timeObj}